<template>
  <div class="navlist">
    <div id="homeside">
        <!-- <img src="./assets/logo/logo.png"  id="logohome"> -->
      <router-link to="/">
      <img src="./../assets/logo/logo.png"
          srcset="./../assets/logo/logo@2x.png 2x,
                  ./../assets/logo/logo@3x.png 3x"
          id="logohome"></router-link>
    </div>    
    <div id="nav" @click="deactiveadvocate()">
      <router-link to="/about">關於金石</router-link>
      <router-link to="/news">最新消息</router-link> 
      <span id="buildinglist" :class="this.ifAdvocate" @click="showlist()" @mouseover="showlist()">
        <router-link to="/advocate" id="advocate">
        金石建案
        </router-link>
        </span> 
      <router-link to="/contactUs">聯絡我們</router-link> 
      <hr>
          <!-- <span class="advocate_container">container</span> -->
    </div>
      <span :class="this.advocate_container" @mouseover="showlist()" @mouseleave="notshowlist()">
        <ul>
          <!-- <li @click="activeadvocate()"><router-link to="/advocate/goldenFront">金石站前湛</router-link></li> -->
          <li @click="activeadvocate()"><router-link to="/advocate/goldenBig">金石成大砌</router-link></li>
          <li @click="activeadvocate()"><router-link to="/advocate/goldenBerkley">金石鉑克萊</router-link></li>
          <li @click="activeadvocate()"><router-link to="/advocate/goldenWorld">金石世築</router-link></li>
          <li @click="activeadvocate()"><router-link to="/advocate/goldenDragon">金石龍悅</router-link></li>
          <li @click="activeadvocate()"><router-link to="/advocate/goldenIntegrity">金石喆學</router-link></li>
          <li @click="activeadvocate()"><router-link to="/advocate/goldenDouble">金石雙響</router-link></li>
          <li @click="activeadvocate()"><router-link to="/advocate/goldenPrime">金石首品I</router-link></li>
          <li @click="activeadvocate()"><router-link to="/advocate/goldenPrime2">金石首品II</router-link></li>
          <li @click="activeadvocate()"><router-link to="/advocate/newPlus">金石+Plus</router-link></li>
          <li @click="activeadvocate()"><router-link to="/advocate/goldenLV">金石 LV</router-link></li>
        </ul>
      </span>
  </div>
</template>

<script>
  export default {
  name: 'navlist',
  data () {
    return {
      advocate_container:'notshown',
      ifAdvocate: 'noneAdvocate'
    }
  },
  methods: {
    showlist(){
      this.advocate_container = 'advocate_container'
    },
    notshowlist(){
      this.advocate_container = 'notshown'
    },
    activeadvocate(){
      this.ifAdvocate = 'active_advocate'
      //console.log(this.ifAdvocate)
    },
    deactiveadvocate(){
      this.ifAdvocate = 'noneAdvocate'
    },
  }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navlist{
  width: 100vw;
  height: 151px;
  display:block;
  position: relative;
  /* background:black; */
}

#homeside{
  position:relative;
  text-align: center;
  float: left;
  width: 46px;
  height: 100%;
  margin: 0 100px 0 53px;
}

#logohome{
  position:relative;
  width: 46px;
  /* height: 100%; */
  margin: 0px auto 0 auto;
}
#logohome:hover{ cursor: pointer;}
/* .icon {
  width: 28px;
  height: 28px;
  margin: 10px auto;
  object-fit: contain;
}

.icon:hover{
  cursor: pointer;
} */

#nav{
  z-index: 40;
  position:relative;
  float: right;
  width: 586px;
  height: 35px;
  margin: 0px 0px 84px 0;
  overflow: hidden;
}

#nav a ,#advocate{
  margin: 74px 25px;
  padding: 1px;
  width: 68px;
  /* height: 19px; */
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.91px;
  color: #7c7a7a;
  text-decoration: none;
}


#nav a.router-link-exact-active,#buildinglis{
  width: 68px;
  height: 19px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.91px;
  color: #d0ad76;
  border-bottom: 1px solid #d0ad76;
}
#nav a:hover, #advocate:hover{
  width: 68px;
  height: 19px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.91px;
  cursor: pointer;
  /* border-bottom: 1px solid #d0ad76; */
}
@keyframes showlist{
  0%  { transform: translateY(-70px); opacity:0}
  65% { opacity:0}
  100%{ transform: translateY(0px);opacity:1}
}
#buildinglist:hover{
  animation: showlist 0.2s ease-in-out forwards;
  -webkit-animation: showlist 0.2s ease-in-out forwards;
  animation-delay: 0s;
  -webkit-animation-delay: 0s;
}
hr{
  margin-left: 30px;
  width: 73.3px;
  height: 0px;
  border: 1px solid #d0ad76;
  display: inline-block;
  vertical-align: middle;
}

.advocate_container{
  z-index: 0;
  /* border: 1px solid #d0ad76; */
  display: inline-block !important;
  position: absolute;
  top: 18px;
  left: 1030px;
  overflow: hidden;
}

ul > li{ 
  width: auto;
  list-style-type: none;
  background: #f2f0f0b4;
  padding: 10px 10px 10px 10px;
  margin: 1px 0;
    animation: showlist 0.9s ease-in forwards;
  -webkit-animation: showlist 0.9s ease-in forwards;
  }

.advocate_container a {
  margin: 74px 25px;
  padding: 1px;
  /* height: 19px; */
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.91px;
  color: #7c7a7a;
  text-decoration: none;
}
.noneAdvocate{border: none}
.advocate_container a:hover{
  border-bottom: 1px solid #d0ad76;
}
/* .active_advocate, #advocate.router-link-exact-active{
  border-bottom: 1px solid #d0ad76;
} */
.advocate_container a.router-link-exact-active {
  /* border-bottom: 1px solid #d0ad76; */
  color: #d0ad76;
}
.notshown{
  display: none;
}
@media screen and (min-width:1600px) and (max-width:1800px){
.advocate_container{
  left: 1274px;
}
}
@media screen and (min-width:1801px){
.advocate_container{
  left: 1526px;
}
}
</style>
